var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Link, useLocation } from 'react-router';
import { CurrentLocationLink } from "../../Layout";








export const ViewDocumentLink = ({ filename, entity, children }) => {
  const location = useLocation();
  const onViewer = location.pathname.match(/entity/);
  const onRelationshipsViewer = location.pathname.match(/relationships/);
  return onViewer && !onRelationshipsViewer ? /*#__PURE__*/
  _jsx(CurrentLocationLink, {
    className: "btn btn-default",
    location: location,
    queryParams: { file: filename, page: 1 },
    type: "button",
    replace: true }, void 0,

  children
  ) : /*#__PURE__*/

  _jsx(Link, {
    className: "btn btn-default",
    to: `/entity/${entity.sharedId}?file=${filename}`,
    type: "button" }, void 0,

  children
  );

};